import { hongKongPositions } from '../hongKong/hongKongPositions'

// Both markets use vexe Contract.positionList's fee-inclusive cost basis.
export const usPositions = rows => hongKongPositions(rows, 'us')
